import { styled, Button } from '@mui/material';

export const ButtonStyled = styled(Button)`
  border-radius: ${({ size }) => (size === 'small' ? 12 : 20)}px;
  height: ${({ size }) => (size === 'small' ? 30 : 56)}px;
`;
